import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import Table from "./Table";
import Pagination from "../Pagination";
import AuthContext from "context/AuthContext";
import dayjs from "dayjs";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import { useTranslation } from "react-i18next";
import ReplyView from "./ReplyView";
import Reply from "./Reply";
import helpers from "../../utils/helpers";
import OSearch from "components/reusable/OSearch";
import CustomSelect from "components/reusable/CustomSelect";
import { supportOptions } from "utils/constants";
import { useLocation } from "react-router-dom";

function SupportManager() {
  const { t } = useTranslation();
  const location = useLocation();

  const { logoutUser, user, updatePageName } = useContext(AuthContext);
  const manager = user?.permission?.find((e) => e.manager === "support_manager") ?? {};
  const [replyShowModal, setReplyShowModal] = useState(false);
  const [replyView, setReplyView] = useState(false);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [users, setAllUser] = useState([]);
  const [item, setItem] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [filterData, setFilterData] = useState({
    category: "",
    searchkey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });

  const handleDeleteAndFilter = (data) => {
    const { isFilter, category } = filterData;

    if ((data?.deletePage && users?.length >= 1) || (isFilter && category && data?.statusChange && users?.length >= 1)) {
      handleDeleteAndFilterCondition();
    } else {
      setIsDelete(false);
    }
  };

  const handleDeleteAndFilterCondition = () => {
    if (users?.length >= 1) {
      setPage(page - 1);
      setIsDelete(true);
      setPaginationObj({ ...paginationObj, page: page - 1 });
    }
  };

  const preparePayload = () => {
    return {
      status: filterData.category,
      page,
      pageSize,
      startDate: helpers?.ternaryCondition(filterData.startDate, dayjs(filterData.startDate).format("YYYY-MM-DD"), null),
      endDate: helpers?.ternaryCondition(filterData.endDate, dayjs(filterData.endDate).format("YYYY-MM-DD"), null),
      keyword: filterData.searchkey?.trim(),
      sortBy: sort.sortBy,
      sortType: sort.sortType,
    };
  };

  const handleApiResponseData = (result) => {
    if (result?.status === 200) {
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;

      setAllUser(response?.docs);

      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(resultStatus, response.totalPages, null),
        perPageItem: helpers?.ternaryCondition(resultStatus, response?.docs.length, null),
        totalItems: helpers?.ternaryCondition(resultStatus, response.totalDocs, null),
      });
    }
  };

  const getAllSupport = async (data) => {
    try {
      handleDeleteAndFilter(data);

      const payload = preparePayload();
      const path = apiPath.getSupport;
      const result = await apiGet(path, payload);

      handleApiResponseData(result);
    } catch (error) {
      console.log("error ", error);
      setPaginationObj({});

      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };
  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchkey: debouncedSearchTerm ? debouncedSearchTerm : "",
        isFilter: debouncedSearchTerm ? true : false,
      });
      setPage(1);
    }
  }, [debouncedSearchTerm]);

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const handleView = (items) => {
    setItem(items);
    setReplyView(!replyView);
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  useEffect(() => {
    updatePageName(t("SUPPORT_MANAGER"));
  }, []);
  useEffect(() => {
    getAllSupport();
  }, [page, filterData, sort]);

  const handelReply = (items) => {
    setItem(items);
    setReplyShowModal(true);
  };

  const handleReset = () => {
    setFilterData({
      category: "",
      searchkey: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setIsDelete(true);
    setSearchTerm("");
  };

  const handleDateChangeSupport = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
    setIsDelete(true);
  };
  const statusPageSupport = (e) => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true });
    setPage(1);
    setIsDelete(true);
  };

  useEffect(() => {
    if (location.state) setFilterData({ ...filterData, category: location.state });
  }, [location.state]);

  return (
    <div>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <form className="border-b border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1 gap-2 px-4 py-3">
              <div className="col-span-2 flex flex-wrap  items-center">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap mb-2">
                  <div className="relative flex items-center mb-3">
                    <OSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} placeholder={t("SEARCH_BY_COMPANY_NAME_EMAIL")} />
                  </div>
                  <ODateRangePicker handleDateChange={handleDateChangeSupport} isReset={filterData?.isReset} setIsReset={setFilterData} />
                  <CustomSelect id="countries" name="floating_password" value={filterData.category} onChange={statusPageSupport} options={supportOptions} placeholder="O_ALL" t={t} />
                  <button type="button" onClick={handleReset} className="bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2">
                    {t("O_RESET")}
                  </button>
                </div>
              </div>
            </form>
            <Table users={users} user={user} getAllSupport={getAllSupport} page={page} handelReply={handelReply} handleView={handleView} setSort={setSort} sort={sort} manager={manager} />
            {paginationObj?.totalItems ? <Pagination handlePageClick={handlePageClick} options={paginationObj} isDelete={isDelete} page={page} /> : null}
          </div>
        </div>
      </div>
      <>
        {replyShowModal ? <Reply setReplyShowModal={setReplyShowModal} users={users} getAllSupport={getAllSupport} item={item} /> : null}
        {replyView && <ReplyView replyView={replyView} item={item} handleView={handleView} getAllSupport={getAllSupport} />}
      </>
    </div>
  );
}
export default SupportManager;
